import { render, staticRenderFns } from "./ReporteIndex.vue?vue&type=template&id=0cafbb2b"
import script from "./ReporteIndex.vue?vue&type=script&lang=js"
export * from "./ReporteIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports